export var emptyDocumentOcr = function () { return ({
    name: '',
    mother_name: '',
    father_name: '',
    birth_date: '',
    birthplace: '',
    parentage: '',
}); };
var normalize = function (text) {
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase();
};
var isPersonName = function (value) {
    return /^[A-Za-z\u00c0-\u017f '\u2019-]{5,}$/.test(value) &&
        value.split(/\s+/).length >= 2 &&
        !/FILIACAO|NASCIMENTO|REPUBLICA|DOCUMENTO|NATURALIDADE|REGISTRO|NACIONALIDADE|SOBRENOME|SURNAME|CARTEIRA|IDENTIDADE/.test(normalize(value));
};
var isLabel = function (value) {
    return /^(?:NOME|NAME|FILIACAO|MAE|PAI|MOTHER|FATHER|DATA|NASCIMENTO|NATURALIDADE|NACIONALIDADE|CPF|RG|REGISTRO|ORGAO|EMISSAO|VALIDADE|ASSINATURA|DOC)/.test(normalize(value));
};
export var extractDocumentOcr = function (text) {
    var data = emptyDocumentOcr();
    var lines = text
        .split(/\r?\n/)
        .map(function (line) { return line.trim().replace(/^[|_\s]+/, '').replace(/^\d{1,2}[a-z]?[.\s-]+(?=[A-Za-zÀ-ÿ])/i, ''); })
        .filter(Boolean);
    var readValue = function (index, label) {
        // Match against normalized text while preserving accents in the original value.
        var match = normalize(lines[index]).match(label);
        if (!match)
            return '';
        var inline = lines[index].slice(match[0].length).trim();
        return inline || (lines[index + 1] && !isLabel(lines[index + 1]) ? lines[index + 1] : '') || '';
    };
    for (var index = 0; index < lines.length; index += 1) {
        var line = normalize(lines[index]);
        if (!data.name &&
            !/^NOME\s+(?:DA\s+MAE|DO\s+PAI|MAE|PAI)\b/.test(line) &&
            /^(?:\d[.\s-]*)?NOME(?:\s+COMPLETO)?\b|^NAME\b/.test(line)) {
            var value = readValue(index, /^(?:\d[.\s-]*)?(?:NOME(?:\s+(?:COMPLETO|E\s+SOBRENOME))?(?:\s*\/\s*(?:NAME|SURNAME|NOMBRE|NOM)(?:\s*(?:AND|E)\s*SURNAME)?)*|NAME)\s*[:/\-]?\s*/);
            if (isPersonName(value))
                data.name = value;
        }
        for (var _i = 0, _a = [
            ['mother_name', /^(?:NOME\s+(?:DA\s+)?)?(?:MAE|MOTHER)\s*[:/\-]?\s*/],
            ['father_name', /^(?:NOME\s+(?:DO\s+)?)?(?:PAI|FATHER)\s*[:/\-]?\s*/],
        ]; _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], label = _b[1];
            if (!data[key] && label.test(line)) {
                var value = readValue(index, label);
                if (isPersonName(value))
                    data[key] = value;
            }
        }
        if (!data.parentage && /^FILIACAO\b/.test(line)) {
            var names = [];
            var inline = readValue(index, /^FILIACAO\s*[:/\-]?\s*/);
            if (isPersonName(inline))
                names.push(inline);
            for (var next = index + 1; next < Math.min(index + 4, lines.length); next += 1) {
                if (isLabel(lines[next]))
                    break;
                if (isPersonName(lines[next]) && !names.includes(lines[next]))
                    names.push(lines[next]);
            }
            data.parentage = names.join(' / ');
        }
        if (!data.birthplace && /^NATURALIDADE\b|^PLACE OF BIRTH\b/.test(line)) {
            var value = readValue(index, /^(?:NATURALIDADE|PLACE OF BIRTH)\s*[:/\-]?\s*/);
            if (/[A-Za-z\u00c0-\u017f]/.test(value))
                data.birthplace = value;
        }
        if (!data.birth_date &&
            /NASCIMENTO|DATE OF BIRTH|BIRTH DATE/.test(line) &&
            !/NATURALIDADE|PLACE OF BIRTH/.test(line)) {
            var match = (lines[index] + ' ' + (lines[index + 1] || '')).match(/\b(\d{2})[/.\-](\d{2})[/.\-](\d{4})\b/);
            if (match) {
                var day = match[1], month = match[2], year = match[3];
                var date = new Date(Number(year), Number(month) - 1, Number(day));
                if (date.getFullYear() === Number(year) &&
                    date.getMonth() === Number(month) - 1 &&
                    date.getDate() === Number(day) &&
                    date <= new Date() &&
                    Number(year) >= 1900)
                    data.birth_date = day + '/' + month + '/' + year;
            }
        }
    }
    return data;
};
